module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAM1BMVEUAAAD6YI/4YY/3YI/4YY//YI/4YJD4YI/4YY/4YJD3YI/4YI/4YI/4YI/6YZH5YI/4YZAf5O2uAAAAEHRSTlMAMMBgsBDw4NBAIHCAkF9QFL80IgAAAL9JREFUKM99U4sOhDAIG+zt+ej/f+2xjLnT5WgMwcCgdtXdoIMLUHgn94bPEJTSYj4fpY2B4GNLow8Ab7NWE5h+FjAS3TXg81zyAbS6JfiFAlKfzHrudZZ7EztFrDWOnHFJzFBqFCAIpG/ILYSxpiMpgSCcDnjtHEikzbvMjto4oKOicCnQdELbUeQZQkxU15BhFs2xJiH7U6YIaRVB9tIf+Wzh7SuzL9u2iW0wtebZrXmqNRdT5x6vhR/ty+/wBVB1D1zBopbmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/reserve/questionnaire/active.png
// module id = MGaf
// module chunks = 1